import { Pipe, PipeTransform } from '@angular/core';

import { dayToLocalDate } from '../functions/zone-day.function';

// Locale bewust op undefined: laat de browser/OS-instelling van de kijker de notatie bepalen
// (dag/maand/jaar-volgorde, 12u/24u), i.p.v. een vaste taal/land hardcoden. Zie
// feedback-memory "Mondiale locale voor datum/getal-notatie" — dit i.v.m. mondiale
// productie-ambitie, los van de tijdzone (die zit al goed via UTC in BE + lokale Date in FE).
export type TAppDateStyle = 'date' | 'dateTime';

@Pipe({
    name: 'appDate',
    standalone: true,
})
export class AppDatePipe implements PipeTransform {

    // weekday: verkorte dagnaam vooraan (bv. 'vr 17-10-2026', 'Fri 10/17/26') — lengte en taal volgen de
    // locale. Standaard aan: deze pipe is alleen voor weergave (Details-secties via readonly
    // input-controls, Compact, lijsten, meldingen); de actieve datumvelden in edit-modus
    // (DateControlComponent) gebruiken hem niet. Los geformatteerd: Intl staat dateStyle niet samen met
    // een losse weekday-optie toe.
    transform(value: Date | string | number | null | undefined, style: TAppDateStyle = 'date', weekday: boolean = true): string {
        if (value == null || value === '') return '';

        // Kale dag ('yyyy-MM-dd', bv. StartDay/EndDay uit de backend): die kalenderdag, niet UTC-middernacht
        // (new Date('yyyy-MM-dd') toont west van UTC de vorige dag).
        const _date = value instanceof Date ? value
            : typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? dayToLocalDate(value)!
            : new Date(value);
        if (isNaN(_date.getTime())) return '';

        const _options: Intl.DateTimeFormatOptions = style === 'dateTime'
            ? { dateStyle: 'short', timeStyle: 'short' }
            : { dateStyle: 'short' };

        const _text = new Intl.DateTimeFormat(undefined, _options).format(_date);
        if (!weekday) return _text;

        const _weekday = new Intl.DateTimeFormat(undefined, { weekday: 'short' }).format(_date);
        return `${_weekday} ${_text}`;
    }
}
